import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { Sheet } from './ui/Sheet';
import { Button } from './ui/Button';

interface UpgradePromptProps {
  open: boolean;
  onClose: () => void;
  // The backend's own explanation (e.g. "You've reached your Free plan's
  // limit of 10 channels...") - shown verbatim when present.
  message?: string;
  title?: string;
}

// Shown when an action is blocked by the caller's pricing tier (see
// api/dataApi.ts LimitError). Routes to the Plan screen to upgrade.
export function UpgradePrompt({ open, onClose, message, title = 'Plan limit reached' }: UpgradePromptProps) {
  const navigate = useNavigate();
  return (
    <Sheet open={open} onClose={onClose} title={title}>
      <div className="flex flex-col gap-4 py-2">
        <p className="text-[15px] text-black/70 dark:text-white/70 m-0">
          {message || 'This action needs a higher plan.'}
        </p>
        <div className="flex gap-2">
          <Button
            variant="primary"
            full
            onClick={() => {
              onClose();
              navigate('/settings/plan');
            }}
          >
            <Sparkles size={16} /> See plans
          </Button>
          <Button variant="bordered" onClick={onClose}>
            Not now
          </Button>
        </div>
      </div>
    </Sheet>
  );
}
